import { Base64 } from "js-base64";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext, SET_PAGE_STATE } from "../../../components/AppProvider";
import {
  AccountMergeResultLayer,
  CustomConfirmLayer,
} from "../../../components/UI/Dialog";
import { InputDivAttch2 } from "../../../components/UI/INPUT/InputDivAttch2";
import {
  PostApi1974,
  PostApiAcntIntg,
  PostApiChkAttct,
  PostApiGnrtAttct,
} from "../../../modules/network/padoPost";
import { _O } from "../../../modules/utils";
import { getCookie, setCookie } from "../../../modules/utils/cookie";
import { autoLogin } from "../../common/AutoLogin/AutoLogin";
import { openLayerFn } from "../../Layout";
import { Header } from "./Header";
import { MergeAcntInfo } from "./MergeAcntInfo";

export const MergeCertification = props => {
  const { userinfo, cfg, phonecfg, dispatch, pageState } =
    useContext(AppContext);
  const [timer, setTimer] = useState(180);
  // 0: 대기, 1: 진행중,
  const [mergeStatus, setMergeStatus] = useState(0);
  const [dialog, setDialog] = useState(
    props.match.params.type === "MERGE"
      ? {
          type: "check",
          title: "계정통합안내",
          msg: "계정 통합에 성공하였습니다 통합계정으로 자가건강관리정보, 진료자료, 교육자료, 병원연동정보가 통합되었습니다",
          msg2: <MergeAcntInfo />,
          data: {},
        }
      : {
          type: "check",
          title: "개인정보수정",
          msg:
            '휴대폰번호가 입력하신 "' +
            props.match.params.phoneNumber +
            '"로 변경되었습니다',
          msg2: "",
          data: {},
        }
  );

  const requestGnrtAttct = () => {
    PostApiGnrtAttct(
      userinfo,
      cfg,
      phonecfg,
      props.match.params.phoneNumber
        ? props.match.params.phoneNumber
        : userinfo.userPhone
    )
      .then(res => {
        console.log("인증번호 발송");
        // requestAcntIntg();
      })
      .catch(err => {
        console.log("err :: ", err);
      });

    setCookie("timer", 180);
  };

  const requestAcntIntg = () => {
    PostApiAcntIntg(
      userinfo,
      cfg,
      phonecfg,
      Base64.decode(props.match.params.trgtUserToken)
    )
      .then(res => {
        if (res.rsltCd === "E000") {
          // setFilesMerge(Base64.decode(props.match.params.trgtUserToken), userinfo.userToken);
          openLayerFn($("#acntMrgLayer"));
        } else {
          alert("정보 통합에 실패했습니다.");
        }
      })
      .catch(err => {
        console.log("err :: ", err);
      });
  };

  const requestChkAttct = () => {
    // setFilesMerge(Base64.decode(props.match.params.trgtUserToken), userinfo.userToken);

    if ($("input[name=certiNo]").val() == "") {
      alert("인증번호를 입력하세요");
    } else {
      PostApiChkAttct(userinfo, cfg, phonecfg, $("input[name=certiNo]").val())
        .then(res => {
          if (res.rsltCd === "E000") {
            if (props.match.params.type === "MERGE") {
              // setMergeStatus(1);
              // setFilesMerge(Base64.decode(props.match.params.trgtUserToken), userinfo.userToken);
              _O.Open(
                "/membership/mergeReady/" + props.match.params.trgtUserToken
              );
            } else {
              updateUserPhone();
              openLayerFn($("#cstmCnfmLayer"));
              numberChangeSucc();
            }
          } else {
            alert("인증번호 확인에 실패하였습니다.");
            1;
          }
          console.log(res);
        })
        .catch(err => {
          console.log("err :: ", err);
        });
    }
  };

  const updateUserPhone = () => {
    PostApi1974(userinfo, cfg, phonecfg, props.match.params.phoneNumber)
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        console.log("err:: ", err);
      });
  };

  const numberChangeSucc = () => {
    autoLogin(
      phonecfg,
      cfg,
      {
        birth: getCookie("birth"),
        sex: getCookie("sex"),
        userEmail: getCookie("userEmail"),
        userName: getCookie("userName"),
        userPhone: props.match.params.phoneNumber,
        userToken: getCookie("userToken"),
      },
      dispatch,
      "",
      "",
      ""
    );
  };

  useEffect(() => {
    requestGnrtAttct();

    // window.NativeInterface = {
    //   setFilesMergeRtn: value => {
    //     setMergeStatus(0);
    //     requestAcntIntg();
    //   },
    // };
  }, []);

  useEffect(() => {
    if (pageState.reload == 1) {
      setMergeStatus(0);
      requestAcntIntg();
      dispatch({
        type: SET_PAGE_STATE,
        data: { type: "reload", state: 1 },
      });
    }
  }, [pageState.reload]);

  useEffect(() => {
    if (mergeStatus === 1) {
      const timerEvent = setInterval(() => {
        if (getCookie("timer") > 0) {
          setCookie("timer", getCookie("timer") - 1);
          setTimer(getCookie("timer") - 1);
        } else {
          alert("정보 통합에 실패했습니다.");
        }
      }, 1000);
      return () => clearInterval(timerEvent);
    }
  }, [mergeStatus]);

  return (
    <ContainerWhite>
      <Header />
      <Title>인증번호</Title>
      <TextArea>
        <TextP>
          {props.match.params.type === "CHANGE" && (
            <Fragment>
              <div>입력하신 휴대폰으로 인증번호가 전송됩니다</div>
              <div>인증번호를 입력하세요</div>
            </Fragment>
          )}
          {props.match.params.type === "MERGE" && "인증번호를 확인하세요"}
        </TextP>
      </TextArea>

      <div style={{ margin: "40px 16px 4px 16px" }}>
        <InputDivAttch2
          type="text"
          name="certiNo"
          style={{ background: "#f7f7f7", borderRadius: "8px" }}
          placeholder="인증번호를 입력하세요"
          maxLength={10}
          requestCertiNo={() => requestGnrtAttct()}
        />
      </div>

      <div style={{ marginLeft: "25px", color: "#B00020", fontSize: "13px" }}>
        네트워크 상태에 따라 2~3분 정도 소요될 수 있습니다.
      </div>

      {/* <BottomBtn onClick={() => openLayerFn($("#acntMrgLayer"))}>확인 </BottomBtn> */}
      <BottomBtn onClick={() => requestChkAttct()}>확인 </BottomBtn>
      <AccountMergeResultLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        msg2={dialog.msg2}
        handleConfirmCB={() => _O.Open("/mp/myInfo/view")}
        handleConfirmCBText={"확인"}
        setCookieBtn={false}
      />

      <CustomConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        msg2={dialog.msg2}
        handleConfirmCB={() => _O.Open("/mp/myInfo/view")}
        handleConfirmCBText={"확인"}
        setCookieBtn={false}
        textAlign="left"
      />
    </ContainerWhite>
  );
};

const MsgCpnt = props => {
  return (
    <div style={{ textAlign: "left" }}>
      <div>휴대폰번호가 입력하신 "{props.phoneNumber}"로 변경되었습니다.</div>
      <div>계정통합을 계속 진행합니다.</div>
    </div>
  );
};

export const ContainerWhite = styled.div`
  background: white;
`;

export const Title = styled.div`
  margin: 37px 16px 0px 16px;
  color: #000;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const TextArea = styled.div`
  margin: 16px 16px 0px 16px;
`;

export const TextP = styled.div`
  color: #888;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const BottomBtn = styled.div`
  display: flex;
  height: 52px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  align-self: stretch;

  border-radius: 6px;
  border: 1px solid #333;
  background: #333;

  color: #fff;
  font-family: Malgun Gothic;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  margin: 0 16px;
  bottom: 24px;
  position: absolute;
  width: calc(100% - 32px);
`;
